import { render } from "./FirstBirthView.vue?vue&type=template&id=4ccd9ed3"
import script from "./FirstBirthView.vue?vue&type=script&lang=js"
export * from "./FirstBirthView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__